import * as React from 'react';
import memoize from 'transmute/memoize';
import partial from 'transmute/partial';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withPartials(Component) {
  class WithPartialsWrapper extends React.Component {
    constructor(props) {
      super(props);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Function' is not assignable to p... Remove this comment to see the full error message
      this.partial = memoize(partial);
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        partial: this.partial
      }));
    }
  }
  WithPartialsWrapper.displayName = `WithPartials(${Component.name})`;
  WithPartialsWrapper.wrappedComponent = Component;
  return WithPartialsWrapper;
}